import { render } from "./MenuView.vue?vue&type=template&id=11fc58c4&scoped=true"
import script from "./MenuView.vue?vue&type=script&lang=js"
export * from "./MenuView.vue?vue&type=script&lang=js"

import "./MenuView.vue?vue&type=style&index=0&id=11fc58c4&lang=scss&scoped=true"

import exportComponent from "/home/timecard-test/OggiTimeClockSystem/electron/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11fc58c4"]])

export default __exports__